module.exports = __webpack_public_path__ + "static/media/logo_b.6c49a508.png";